import { axiosInstance } from './axiosInstance';

export function getUniAdmins(id, token) {
    return axiosInstance(token,id).get("/api/v1/admins")
}

export function editUniAdmin(uniId, adminId, data, token) {
    return axiosInstance(token,uniId).put(`/api/v1/admins/${adminId}`, data)
}

export function addUniAdmin(uniId, data, token) {
    return axiosInstance(token,uniId).post('/api/v1/admins', data)
}

export function removeUniAdmin(id, token) {
    return axiosInstance(token,id).delete(`/api/v1/admins/${id}`)
}